import { useEffect, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'

const NoData = () => {
  const { t } = useTranslation('common')
  const [isDisplay, setIsDisplay] = useState(false)
  const email = JSON.parse(localStorage.getItem('userData'))?.data?.email || ''
  const allDeviceUser = JSON.parse(localStorage.getItem('allDeviceUser')) || []
  const time = allDeviceUser?.[0]?.createdAt || null

  useEffect(() => {
    if (!email || !time) return
    const inputTime = new Date(time).getTime()
    const now = Date.now()
    const oneHourAgo = now - 60 * 60 * 1000
    const shouldDisplay = inputTime > oneHourAgo

    setIsDisplay(shouldDisplay)
    localStorage.setItem(`isDisplay-${email}`, JSON.stringify(shouldDisplay))
  }, [email, time])

  useEffect(() => {
    if (!email) return
    const stored = localStorage.getItem(`isDisplay-${email}`)
    setIsDisplay(stored === 'true')
  }, [email])

  const NoDisplay = () => {
    setIsDisplay(false)
    localStorage.setItem(`isDisplay-${email}`, JSON.stringify(false))
  }

  return (
    <>
      {isDisplay &&
        <div className='[box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white p-5 pt-1 mb-5'>
          <div className='flex justify-end'><button className='text-[28px] h-[30px] smjs:translate-y-[20px]' onClick={() => NoDisplay()}>×</button></div>
          <div className='flex'>
            <img src='/welcome.svg' width={32} height={32} alt='welcome' className='w-[32px] h-[32px]' />
            <div className='ml-5 smjs:pr-6'>
              {t('Welcome We')}
            </div>
          </div>
        </div>}
    </>
  )
}

export default NoData
